import { render, staticRenderFns } from "./DoubleCodePop.vue?vue&type=template&id=5fbfba20&scoped=true&"
import script from "./DoubleCodePop.vue?vue&type=script&lang=js&"
export * from "./DoubleCodePop.vue?vue&type=script&lang=js&"
import style0 from "./DoubleCodePop.vue?vue&type=style&index=0&id=5fbfba20&lang=scss&scoped=true&"
import style1 from "./DoubleCodePop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfba20",
  null
  
)

export default component.exports